import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ custom, palette }: Theme) => ({
  radioGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    marginTop: 16,
  },
  option: {
    width: '100%',
    margin: 0,
    borderRadius: 8,
    border: `1px solid ${custom.grey[11]}`,
    height: 58,
    padding: '0 10px',
    color: custom.grey[3],
    alignItems: 'center',
  },
  optionActive: {
    borderColor: palette.primary.main,
    backgroundColor: custom.status.warning.main,
  },
  radio: {
    marginRight: 10,
    padding: 0,
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    fontSize: 16,
    fontWeight: 400,
    color: custom.grey[3],
    lineHeight: '22px',
  },
  iconImage: {
    width: 48,
    height: 'auto',
    display: 'block',
    flexShrink: 0,
  },
  bottomInfoMessage: {
    backgroundColor: 'transparent',
    padding: 0,
  },
}));
